import React from "react";
import styles from "./RadioInput.module.scss";

const RadioInput = ({ name, label, value, isChecked, handleChange }) => {
  const handleRadioChange = (e) => {
    const { id } = e.currentTarget;
    handleChange(id);
  };

  return (
    <div className={styles.radioInput}>
      <input
        type="radio"
        className={styles.customRadio}
        name={name}
        id={value}
        checked={isChecked}
        onChange={handleRadioChange}
      />
      <label htmlFor={value}>{label}</label>
    </div>
  );
};

export default RadioInput;
